import React from "react";

import Page from "../../../../layouts/Main/Page";
import ApartmentProvider, {useApartment} from "./ApartmentContext";
import ApartmentActionProvider from "./ApartmentActionContext";
import ApartmentHeader from "./ApartmentHeader";
import ApartmentTabs from "./ApartmentTabs";
import {useAccommodationsPage} from "../../AccommodationContext";
import MenuDots from "../../../../components/MenuDots";
import {useFeedbackTools} from "../../../../components/FeedbackTools";
import {useArchiveApartmentMutation} from "../../query";

import Container from "@mui/material/Container";
import DeleteIcon from "@mui/icons-material/Delete";
import {useHome} from "../HomeContext";


const Apartment = (props) => {
    const {apartmentId} = props

    return <ApartmentProvider apartmentId={apartmentId}>
        <ApartmentActionProvider>
            <ApartmentPage {...props}/>
        </ApartmentActionProvider>
    </ApartmentProvider>
}

const ApartmentPage = (props) => {
    const {onClose} = props
    const {selectedHomeName} = useAccommodationsPage();
    const {name, isLoading, id: apartmentId} = useApartment();
    const {deleteApartment} = useHome();
    const archiveApartmentMutation = useArchiveApartmentMutation({apartmentId: apartmentId});
    const {showErrorNotification, askConfirmation} = useFeedbackTools();

    const handleArchive = () => {
        const innerArchive = async () => {
            try{
                await archiveApartmentMutation.mutateAsync();
                deleteApartment(apartmentId);
                onClose();
            }catch(e){
                showErrorNotification(e);
            }
        }
        askConfirmation({
            title: "Elimina appartamento",
            description: `Confermi l'eliminazione dell'appartamento selezionato?`,
            confirmationText: 'Si',
            cancellationText: 'No',
            onConfirm: innerArchive
        });
    }

    const title = !isLoading ? `${selectedHomeName} - ${name}` : selectedHomeName
    return <Page title={title}
                 disablePadding
                 onBack={onClose}
                 onClose={onClose}
                 loading={isLoading}
                 actions={<MenuDots options={[{label: "Elimina", icon: <DeleteIcon fontSize="small"/>, onClick: handleArchive}]}/>}
                 overlay>
        <ApartmentContent/>
    </Page>
}

const ApartmentContent = () => {
    return <Container maxWidth="md"
                      disableGutters={true}
                      sx={{mb: 4}}>
        <ApartmentHeader/>
        <ApartmentTabs/>
    </Container>
}


export default Apartment;